export default function eq(left, right) {
  return left === right;
}